import React from 'react';
import { CheckIcon, FlameIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { BOX_IMAGE, offerAssurances, offerChecklist } from '../data/content';
export function OfferSection() {
  return <section id="offer" className="w-full bg-slate-950 px-5 pb-14" data-id="element-135" data-mp="8m3xzt5shi01">
      <div className="mx-auto max-w-[680px]" data-id="element-136" data-mp="df6ua91yb5jx">
        <p className="text-center text-[0.85rem] font-extrabold uppercase tracking-[0.3em] text-white/90" data-id="element-137" data-mp="dg8306vhvfyh">
          Special Launch Offer
        </p>

        <div className="mt-4 rounded-lg border-2 border-orange-600/70 bg-slate-900 p-5 text-center sm:p-8" data-id="element-138" data-mp="mds8xt4ay0ff">
          <p className="flex items-center justify-center gap-2 text-[1.15rem] font-extrabold uppercase leading-[0.95] tracking-tight text-orange-500 sm:text-[1.3rem]" data-id="element-139" data-mp="rf7urneb0ayv">
            <ZapIcon className="h-5 w-5 fill-orange-500" aria-hidden="true" data-id="element-140" data-mp="2t5t1ctvai70y" />
            Health Ready™
          </p>
          <h2 className="mt-2 text-balance text-[1.1rem] font-extrabold uppercase leading-tight tracking-tight text-white sm:text-[1.3rem]" data-id="element-141" data-mp="2y3kv7tfhw37s">
            The Complete System to Organize an Entire Year of Health Education
          </h2>

          <img src={BOX_IMAGE} alt="The complete HEALTH READY™ bundle" className="mx-auto mt-6 w-full max-w-[300px]" width={1240} height={1240} data-id="element-142" data-mp="xvh4uahgv58q" />

          <p className="mt-6 text-[1.05rem] font-extrabold uppercase tracking-tight text-white" data-id="element-143" data-mp="ouaihks4z07k">
            Complete 6-in-1 Bundle
          </p>

          <ul className="mx-auto mt-4 grid max-w-md gap-x-6 gap-y-2 text-left sm:grid-cols-2" data-id="element-144" data-mp="1gocn68e7mku9">
            {offerChecklist.map(item => <li key={item} className="flex gap-2 text-[0.95rem] text-white" data-id="element-145" data-mp="1cnsov1hwhb6j">
                <CheckIcon className="mt-1 h-3.5 w-3.5 shrink-0 text-orange-500" strokeWidth={4} aria-hidden="true" data-id="element-146" data-mp="17m3bvgb4anft" />
                {item}
              </li>)}
          </ul>

          <div className="mx-auto mt-7 max-w-sm rounded-md border border-orange-500/40 bg-slate-950 px-5 py-5" data-id="element-147" data-mp="3tthouscyp06s">
            <p className="text-[0.95rem] font-bold text-white/80" data-id="element-148" data-mp="2nya1gfnskt2">
              Regular Value:{' '}
              <span className="line-through decoration-orange-500 decoration-2" data-id="element-149" data-mp="3ks9ps82mfvbn">
                $97 USD
              </span>
            </p>
            <p className="mt-3 flex items-center justify-center gap-2 text-[1rem] font-extrabold uppercase tracking-tight text-orange-500" data-id="element-150" data-mp="3owzmfz53tdxm">
              <FlameIcon className="h-4 w-4 fill-orange-500" aria-hidden="true" data-id="element-151" data-mp="3fuqdhdphhsmc" />
              Today Only
            </p>
            <p className="mt-1 text-[4rem] font-black leading-none tracking-tight text-orange-500 sm:text-[4.6rem]" data-id="element-152" data-mp="316dgqeiko5qs">
              $27{' '}
              <span className="align-top text-[1.4rem] font-black sm:text-[1.6rem]" data-id="element-153" data-mp="3622goiyi7onm">
                USD
              </span>
            </p>
            <p className="mx-auto mt-3 inline-block rounded bg-orange-500 px-2.5 py-1 text-[0.8rem] font-black uppercase tracking-wide text-slate-950" data-id="element-154" data-mp="2x407vh8j3rps">
              Save $70 USD
            </p>
            <p className="mt-3 text-[0.95rem] font-extrabold uppercase tracking-tight text-white" data-id="element-155" data-mp="28jdr5buu4i0a">
              One-Time Payment · No Subscription
            </p>
          </div>

          <CtaButton label="Yes! I Want It for $27 USD" subLabel="Get Instant Access Today" className="mt-6 w-full" data-id="element-156" data-mp="2ih1n2546fvk1" />

          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[0.75rem] font-bold uppercase tracking-wide text-white" data-id="element-157" data-mp="2weykf3qgg5zr">
            {offerAssurances.map(item => <li key={item} className="flex items-center gap-1.5" data-id="element-158" data-mp="365t4c1g8ati1">
                <ShieldCheckIcon className="h-3.5 w-3.5 shrink-0 text-orange-500" aria-hidden="true" data-id="element-159" data-mp="318knc46tgvid" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}